import React, { forwardRef, useState, useEffect }  from 'react';
import { Colors } from '../../../constants';

const CustomLongText = forwardRef((props, ref) => {
    const [ focusBorderColor, setFocusBorderColor ] = useState(`#${Colors.primaryColor}`);

    useEffect(() => {
        setFocusBorderColor(`#${Colors.disabledText}`);
    },
    []);

    let url = props.data['name'].toLowerCase()?.split(" ").join("_");
    if(url[url.length-1] === '_') {
        url = url.slice(0, -1);
    }
    let text_default_value = props.URL_PARAMS.get(url) || "";

    return (
        <div className="input-section" key={props.index}>
            <div className="input-nav field-label">
                <label>
                    {props.data['name']}

                    { props.data['required'] && (
                        <span className="required" style={{ color: props.color }}> *</span>
                    )}
                </label>
                <div className="field-input">
                        <textarea
                            required={props.data['required']}
                            ref={ref}
                            defaultValue={text_default_value}
                            rows={5}
                            className="input height-auto"
                            style={{
                                paddingTop: '0.7rem',
                                paddingBottom: '0.7rem',
                                borderColor: focusBorderColor
                            }}
                            onFocus={ () => setFocusBorderColor(props.color) }
                            onBlur={ () => setFocusBorderColor(`#${Colors.disabledText}`) } />
                </div>
            </div>
        </div>
    );
});

export default CustomLongText;
